<template>
  <div class="choose-service-page" v-slideIn>
    <div class="page-head-container">
      <PageHead pageName="选择服务" />
    </div>
    <Steps :current="2" />
    <div class="content-area" v-loading.lock="loading">
      <h3 class="title">
        请选择要开通的服务
        <span class="required-symbol">*</span>
      </h3>
      <div class="choose-service-type">
        <radio-group
          @change="handleChange"
          name="companyName"
          v-model="accountType"
        >
          <radio-button
            label="企业账户"
            :value="1"
            :disabled="isIndividualCert"
          />
          <radio-button
            label="个人账户"
            :value="2"
            :disabled="isEnterpriseCert"
          />
        </radio-group>
      </div>
      <keep-alive>
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>
<script>
import Steps from '@/components/Steps';
import PageHead from '@/components/PageHead';
import RadioGroup from '@/components/Radio';
import RadioButton from '@/components/Radio/radioButton';

import { routes, certificationStatusCode } from '@/config';
import api from '@/api';

export default {
  name: 'c-choose-service',
  data() {
    return {
      accountType: 2,
      loading: true,
      isEnterpriseCert: false,
      isIndividualCert: false,
    };
  },
  created() {
    setTimeout(() => {
      let baseTitle = JSON.parse(localStorage.getItem('WEB_INFO')).title || '';
      document.title = `${baseTitle} - 开通服务`;
    }, 500);
    this.init();
  },
  methods: {
    async init() {
      this.loading = true;
      await this.fetchCertInfo();
      // await this.fetchAppliedInfo();
      this.loading = false;
      const routeName = this.$route.name;

      if (this.isEnterpriseCert && routeName !== routes.chooseCompany.name) {
        this.accountType = 1;
        this.goCompany();
        return;
      }

      if (this.isIndividualCert && routeName !== routes.choosePersonal.name) {
        this.accountType = 2;
        this.goPersonal();
        return;
      }
    },
    goCompany() {
      if (this.$route.name === routes.chooseCompany.name) {
        return;
      }
      this.$router.replace({
        name: routes.chooseCompany.name,
        query: this.$route.query,
      });
    },
    goPersonal() {
      if (this.$route.name === routes.choosePersonal.name) {
        return;
      }
      this.$router.replace({
        name: routes.choosePersonal.name,
        query: this.$route.query,
      });
    },
    handleChange(value) {
      if (value === 1) {
        this.goCompany();
      } else {
        this.goPersonal();
      }
    },
    fetchAppliedInfo() {
      // 由于没法区分当前被驳回的到底是企业资质还是个人，暂时没法做。
      // TODO:根据后台返回的审核结果自动勾选上次申请被驳回的服务和身份。
      return api.getServiceInfo().then((res) => {
        if (res.code !== 0) {
          return;
        }
        const list = res.data;
        const applidIdentity = list.find((el) => {
          return el.identity.find(
            (el) => certificationStatusCode.reject === el.status
          );
        });
      });
    },
    fetchCertInfo() {
      return api.checkCertStatus().then((res) => {
        if (res.code === 0) {
          const data = res.data;
          this.isEnterpriseCert = !!data.isEnterpriseCert;
          this.isIndividualCert = !!data.isIndividualCert;

          if (!this.isEnterpriseCert && !this.isIndividualCert) {
            this.accountType = this.$route.name === 'choose-company' ? 1 : 2;
          } else {
            this.accountType = this.isEnterpriseCert ? 1 : 2;
          }
        }
      });
    },
  },
  components: { Steps, PageHead, RadioGroup, RadioButton },
};
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
